import { Middleware } from 'redux'

import { cacheValidAfter, stateSyncBuffer } from '../../config'
import { credentials }                      from '../../project-utils/credentials-cookie'
import { ApplicationState }                 from '../ducks'

const throttle = require('lodash/throttle')

type BrowserStorage = typeof window.localStorage

export const loadState = (storage: BrowserStorage): ApplicationState | undefined => {
  try {
    const cacheAge = window.localStorage.getItem('cache-age')

    if (!cacheAge || (Number(cacheAge) < cacheValidAfter)) {
      window.localStorage.setItem('cache-age', String(Date.now()))
      return { auth: credentials } as ApplicationState
    }

    const serializedState = storage.getItem('state')

    if (serializedState === null) {
      return { auth: credentials } as ApplicationState
    }

    return {
      ...JSON.parse(serializedState),
      auth: credentials,
    } as ApplicationState
  } catch (e) {
    console.warn(e)
    return undefined
  }
}

export const saveStateAsync = (state: Partial<ApplicationState>, storage: BrowserStorage) => {
  return new Promise((res, rej) => {
    try {
      const serializedState = JSON.stringify(state)
      res(serializedState)
    } catch (e) {
      rej(e)
    }
  }).then((serializedState: string) => {
    return new Promise((res, rej) => {
      try {
        storage.setItem('state', serializedState)
        res(true)
      } catch (e) {
        rej(e)
      }
    })
  })
}

export const createStorageMiddleWare = (storage: BrowserStorage): Middleware => {
  return throttle(
    (store: any) => (next: any) => (action: any) => {
      next(action)

      const
        {
          account,
          auth,
          companies,
          programs,
          processes,
          resources,
          sessions,
          settings,
          tripartita,
          users,
        }: ApplicationState = store.getState()

      saveStateAsync(
        {
          account,
          auth,
          companies,
          programs,
          processes,
          resources,
          sessions,
          settings,
          tripartita,
          users,
        },
        storage,
      ).catch(
        /* tslint:disable-next-line */
        e => console.warn(
          new Error(
            'write problem while trying to write to the browsers storage',
          ),
          e,
        ),
      )
    },
    stateSyncBuffer,
  )
}



// WEBPACK FOOTER //
// ./src/redux/middlewares/storage.middleware.ts